import { render, staticRenderFns } from "./QuestionLayoutI.vue?vue&type=template&id=2bd14d8e&scoped=true&"
import script from "./QuestionLayoutI.vue?vue&type=script&lang=js&"
export * from "./QuestionLayoutI.vue?vue&type=script&lang=js&"
import style0 from "./QuestionLayoutI.vue?vue&type=style&index=0&id=2bd14d8e&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd14d8e",
  null
  
)

export default component.exports